import { render, staticRenderFns } from "./TaskListPromoCarousel.vue?vue&type=template&id=e40cb7b0&scoped=true"
import script from "./TaskListPromoCarousel.vue?vue&type=script&lang=js"
export * from "./TaskListPromoCarousel.vue?vue&type=script&lang=js"
import style0 from "./TaskListPromoCarousel.vue?vue&type=style&index=0&id=e40cb7b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40cb7b0",
  null
  
)

export default component.exports